import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { Profile } from '../../../../models/UserStore';
import {
  AppBar,
  AvatarNode,
  ListItemProps,
  SettingList,
  SvgIcon,
  TextButton,
  TextButtonSize,
  TextButtonVariant,
} from '../../../Molecules';

import styles from './AccountInfoTemplate.module.css';

type AccountInfoTemplateProps = {
  profile: Profile | undefined;
  accountListData: ListItemProps[];
  regionListData: ListItemProps[];
  onClickTrialLogout: () => void;
};

export const AccountInfoTemplate = memo(
  ({
    profile,
    accountListData,
    regionListData,
    onClickTrialLogout,
  }: AccountInfoTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className={styles.container}>
        <AppBar
          leading={
            <SvgIcon
              name={SVGIconType.PersonLine}
              width={32}
              height={32}
              stroke={'#333'}
              fill="none"
            />
          }
          title={t('Account Information')}
        />
        <div className={styles.accountInfo}>
          {/* <p className={styles.textTitle}>{t('Account Information')}</p> */}
          <div style={{ marginBottom: '1rem' }}>
            {profile && <AvatarNode profile={profile} size={140} />}
          </div>
          <div className={styles.centeredContainer}>
            <div className={styles.settingList}>
              <SettingList data={accountListData} />
            </div>
          </div>
          <br />

          <div className={styles.centeredContainer}>
            <div className={styles.settingList}>
              <SettingList data={regionListData} />
            </div>
          </div>

          {profile?.isTrialUser && (
            <div className={styles.trialLogout}>
              <TextButton
                text={t('Delete Account')}
                size={TextButtonSize.Medium}
                variant={TextButtonVariant.WarningWhiteBg}
                onClick={onClickTrialLogout}
              />
            </div>
          )}
        </div>
      </div>
    );
  },
);
